import React from 'react';
import { useCampaignsContext, CampaignInterface } from 'pages/Campaigns/campaigns.context';
import UpdateCampaign from 'pages/Campaigns/UpdateCampaign';
import CreateCampaign from 'pages/Campaigns/CreateCampaign';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import { TableColumnInterface } from 'components/Table/table.types';
import OverviewTable from 'components/Table/Table';
import { IconBox } from 'components/StyledComponents/IconBox';
import { Store, User } from '@restore/services-lib';
import ArchiveCampaign from 'pages/Campaigns/ArchiveCampaign';
import { Link } from 'react-router-dom';
import { Tag } from 'components/Tag/Tag';
import { formatDatePickerDate, truncateText } from 'utils/formatting';
import CampaignFilters from 'pages/Campaigns/Table/Filters';
import TagTableCellContainer from 'components/Tag/TagHelpers/TagTableCellContainer';

const CampaignsTable = (): JSX.Element => {
  const { campaigns } = useCampaignsContext();

  const tableCols: TableColumnInterface<CampaignInterface>[] = [
    { label: 'ID', value: (campaign) => campaign.id },
    {
      label: 'Name',
      value: (campaign) => (
        <Link to={`/campaigns/${campaign.id}`}>{truncateText(campaign?.name, 30)}</Link>
      ),
      sortBy: 'name',
    },
    {
      label: 'Stores',
      value: (campaign) => campaign.stores.map((store: Store) => store.name).join(', '),
    },
    {
      label: 'Users',
      value: (campaign) =>
        campaign.users.map((user: User) => `${user.firstName} ${user.lastName}`).join(', '),
    },
    {
      label: 'Start Date',
      value: (campaign) => formatDatePickerDate(campaign.startDate),
      sortBy: 'startDate',
    },
    {
      label: 'End Date',
      value: (campaign) => formatDatePickerDate(campaign.endDate, 'Ongoing'),
      sortBy: 'endDate',
    },
    {
      label: 'Tags',
      value: (tagGroup) => (
        <TagTableCellContainer>
          {tagGroup.tags.map((tag) => (
            <Tag key={tag.id} color={tag.displayColour} text={tag.name} />
          ))}
        </TagTableCellContainer>
      ),
    },
    {
      label: '',
      align: 'right',
      value: (campaign) => (
        <IconBox>
          <UpdateCampaign campaign={campaign} />
          <ArchiveCampaign campaign={campaign} />
        </IconBox>
      ),
    },
  ];

  return (
    <>
      <CampaignFilters />
      <OverviewTable
        data={campaigns.filter((campaign) => !campaign.archived)} // TODO HR20-285: add filters to campaigns
        columns={tableCols}
        tableTitle='Campaigns'
        noDataMessageOverride={<EmptyData dataType='campaign' action={<CreateCampaign />} />}
      />
    </>
  );
};

export default CampaignsTable;
